import { render, staticRenderFns } from "./PropertySelectDropdown.vue?vue&type=template&id=fafc140c&scoped=true"
import script from "./PropertySelectDropdown.vue?vue&type=script&lang=js"
export * from "./PropertySelectDropdown.vue?vue&type=script&lang=js"
import style0 from "./PropertySelectDropdown.vue?vue&type=style&index=0&id=fafc140c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafc140c",
  null
  
)

export default component.exports